import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM';

export class Lookbook extends UcoastEl {
    static htmlSelector = 'lookbook-item'
    trigger: HTMLButtonElement

    constructor() {
        super()

        this.trigger = q.rs('.lookbook-trigger', this)

        this.trigger.addEventListener('click', (e) => {
            e.preventDefault()
            this.classList.toggle('active')
        })

        document.body.addEventListener('click', (e) => {
            const target = e.target as HTMLElement
            if(target.closest('lookbook-item')) return
            this.classList.remove('active')
        })
    }
}
